import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

Alpine.data('stackedmemorylayers', () => ({
    media: null,

    init() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const stackedMemoryLayers = this.$root;
        const pin = stackedMemoryLayers.querySelector('.stacked-memory-layers__pin');
        const items = gsap.utils.toArray(stackedMemoryLayers.querySelectorAll('[data-stacked-memory-layers-item]'));

        if (!pin || !items.length) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        this.media = gsap.matchMedia();
        this.media.add('(max-width: 767px)', () => {
            const timelines = items.map((item, index) =>
                gsap.fromTo(
                    item,
                    {
                        y: index % 2 === 0 ? 36 : 18,
                        opacity: 0.72,
                    },
                    {
                        y: index % 2 === 0 ? -28 : -16,
                        opacity: 1,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                            invalidateOnRefresh: true,
                        },
                    }
                )
            );

            return () => {
                timelines.forEach((timeline) => timeline.kill());
                gsap.set(items, { clearProps: 'transform,opacity' });
            };
        });

        this.media.add('(min-width: 768px)', () => {
            gsap.set(items, {
                opacity: 0,
                scale: 0.84,
                y: 120,
                xPercent: -50,
                yPercent: -50,
                rotateZ: 5,
                zIndex: (index) => index + 1,
            });

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: stackedMemoryLayers,
                    start: 'top top',
                    end: () => `+=${items.length * 420}`,
                    pin,
                    scrub: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                },
            });

            items.forEach((item, index) => {
                const position = index * 0.9;

                timeline
                    .to(
                        item,
                        {
                            opacity: 1,
                            scale: 1,
                            y: 0,
                            xPercent: -50,
                            yPercent: -50,
                            rotateZ: 0,
                            duration: 0.8,
                            ease: 'power1.out',
                        },
                        position
                    )
                    .to(
                        item,
                        {
                            opacity: index === items.length - 1 ? 1 : 0.2,
                            scale: index === items.length - 1 ? 1 : 0.9,
                            y: index === items.length - 1 ? 0 : -92,
                            xPercent: -50,
                            yPercent: -50,
                            rotateZ: index === items.length - 1 ? 0 : index % 2 === 0 ? -3 : 3,
                            duration: 0.8,
                            ease: 'power1.inOut',
                        },
                        position + 0.75
                    );
            });

            return () => {
                timeline.kill();
                gsap.set(items, { clearProps: 'transform,opacity,zIndex' });
            };
        });

        requestAnimationFrame(() => ScrollTrigger.refresh());
    },

    destroy() {
        this.media?.revert();
    },
}));
